export const allDevicesPanelIconToggle = () => {
    var panelLinks = $('.panel-group').find('.panel-title').find('a'),
        thePanels = $('.panel-collapse');
    $.each(panelLinks, function() {
    	panelLinks.off("click.panel");
        panelLinks.on('click.panel', function(e) {
        	e.stopPropagation();
	          if ($(this).hasClass('collapsed')) {
	            $(this).removeClass('collapsed');
	            $(this).parents('.panel-default').find('.panel-collapse').removeClass('collapse');
	          } else {
	            $(this).addClass('collapsed');
	            $(this).parents('.panel-default').find('.panel-collapse').addClass('collapse');
	          }
        });
    });
    $('.footer-top-link-section.footer-closed').off('click.openFooter');
    $('.footer-top-link-section.footer-closed').on('click.openFooter', function() {
      $(this).toggleClass('footer-open');
    });
};
